import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './modules/router-map'
import getJob from './modules/getJob'
import distribution from './modules/distribution'
import project from './modules/project'
import staticPages from './modules/staticPages'
import news from './modules/news'
import service from './modules/service'
import training from './modules/training'
import friendCircle from './modules/friendCircle'
import integralMall from './modules/integralMall'
import coins from './modules/coins'
import activity from './modules/activity'
import { getRequest } from '@/libs/utils'
import gongZhongHao from './modules/gongZhongHao'
import record from './modules/record'
import contentNews from './modules/contentNews'
import wxQr from './modules/wxQr'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...routes, // 公用
    ...getJob, // 找活
    ...distribution, // 招工
    ...project, // 项目
    ...service, // 服务
    ...training, // 学习培训
    ...staticPages, // 静态页面
    ...news, // 消息
    ...friendCircle, // 工友圈
    ...integralMall, // 积分商城
    ...coins, // 邀功币
    ...activity, // 活动
    ...gongZhongHao, // 公众号推广
    ...record, // 记功记账
    ...contentNews, //邀工资讯
    ...wxQr //邀工资讯
  ]
})

router.beforeEach((to, from, next) => {
  const requestInfo = getRequest()
  const token = requestInfo.token
  const companyId = requestInfo.companyId
  const scale = Number(requestInfo.scale) // 字体放大倍数

  // localStorage.setItem('token', token)
  // localStorage.setItem('companyId', companyId)

  if (window.location.toString().indexOf('/coinsRecharge') === -1) {
    // alert(window.location.toString())
    localStorage.setItem('token', token)
    localStorage.setItem('companyId', companyId)
  }

  if (requestInfo.scale) {
    window.document.documentElement.setAttribute('data-dpr', scale)
  }
  // window.document.documentElement.setAttribute('data-dpr', 1.4)
  next()
})
export default router
